module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', _vm._l((_vm.content), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v(_vm._s(item.labelName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.labelValue))])])
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5edcc4ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/todo/defaultTodo.vue
// module id = d132
// module chunks = 0